import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPhoneNumberIntl, Value } from 'react-phone-number-input';
import { Link } from 'react-router-dom';
import { TDR } from 'tdr-common';
import layoutStyles from '../../layouts/CheckoutLayout.module.scss';
import { SubHeader } from '../headers/SubHeader';
import { EmailIcon, GuestIcon, PhoneIcon } from '../icons';
import styles from './GuestDetails.module.scss';

export interface GuestDetailsProps {
	reservation: TDR.Reservation;
}

export function GuestDetails({ reservation }: GuestDetailsProps) {
	const { t } = useTranslation();
	return (
		<div className={layoutStyles.Section}>
			<div className={styles.Header}>
				<SubHeader title={t('titles.contact_details')} />
				<Link to='modify/guest' aria-label={t('aria.edit_contact_details')} className={styles.Button}>
					<span>{t('actions.edit')}</span>
				</Link>
			</div>

			<div className={layoutStyles.SubSection}>
				<div className={styles.Item}>
					<GuestIcon />
					{reservation.fullName}
				</div>

				<div className={styles.Item}>
					<EmailIcon />
					{reservation.email}
				</div>

				<div className={styles.Item}>
					<PhoneIcon />
					{formatPhoneNumberIntl(reservation.phone as Value)}
				</div>
			</div>
		</div>
	);
}
